import * as React from 'react';
import { Element as ReactScrollElement } from 'react-scroll';
import { Subscription } from 'rxjs';

// services
import ubisoftOverlayService from 'modules/ubisoft-overlay-service';

// components
import GameLogo from 'components/game-logo';
import FAQ from '../faq';
import StepsDescription from '../steps-description';

// constants
import { SUB_CONTENT_SCROLL_ELEMENT } from 'components/content/content.constants';

// types
import { IContentProps } from './content.container';
// styles
import './content.styles.less';
// utils
import { getModeClass } from 'utils/css';
import { WEBSITE_MODE } from '@sitegen/common/constants';

export class Content extends React.Component<IContentProps> {
    private overlayLogoutSubsription: Subscription;
    private overlayLoginSubsription: Subscription;

    public componentDidMount() {
        this.overlayLoginSubsription = ubisoftOverlayService
            .overlayLoginTriggerSubject
            .subscribe(this.onOverlayLoginChange);

        this.overlayLogoutSubsription = ubisoftOverlayService
            .overlayLogoutTriggerSubject
            .subscribe(this.onOverlayLogoutChange);
    }

    public componentWillUnmount() {
        this.overlayLoginSubsription.unsubscribe();
        this.overlayLogoutSubsription.unsubscribe();
    }

    public onOverlayLogoutChange = () => {
        return this.props.logOut();
    };

    public onOverlayLoginChange = () => {
        return this.props.requestLoginSession();
    };

    public renderLogo = () => {
        const { shouldInheritStyles } = this.props;

        return !shouldInheritStyles && this.props.showGameLogo ? <GameLogo /> : null;
    };

    public renderStaticSection = () => {
        const { mode } = this.props;

        if (mode === WEBSITE_MODE.EMBEDDED) {
            return null;
        }
        return  (
            <div className="sitegen-fr-static-section">
                <StepsDescription/>
                <FAQ/>
            </div>
        );
    };

    public render() {
        const { shouldInheritStyles } = this.props;
        return (
            <div className={getModeClass('sitegen-content-wrapper', shouldInheritStyles)}>
                <div className={getModeClass('sitegen-fr-top-section', shouldInheritStyles)}>
                    {this.renderLogo()}
                    <ReactScrollElement
                        className={`${getModeClass('sitegen-fr-top-section', shouldInheritStyles)}__inner`}
                        name={SUB_CONTENT_SCROLL_ELEMENT}
                    >
                        {this.props.children}
                    </ReactScrollElement>
                </div>
                {this.renderStaticSection()}
            </div>
        );
    }
}

export default Content;
